import { CaretLeft, CaretRight } from "@phosphor-icons/react";

const WD = ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"];
export const COLOR_MAP = { merah: "bg-red-500", kuning: "bg-yellow-400", hijau: "bg-green-500", biru: "bg-blue-500", ungu: "bg-purple-500" };
export const COLORS = [["merah", "Merah"], ["kuning", "Kuning"], ["hijau", "Hijau"], ["biru", "Biru"], ["ungu", "Ungu"]];

export function MonthCalendar({ ym, setYm, entries, onDayClick }) {
  const [y, m] = ym; // m: 0-indexed
  const first = new Date(y, m, 1);
  const startOffset = (first.getDay() + 6) % 7; // Monday-first
  const days = new Date(y, m + 1, 0).getDate();
  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= days; d++) cells.push(d);
  const monthName = first.toLocaleDateString("id-ID", { month: "long", year: "numeric" });
  const ds = (d) => `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const byDate = {};
  (entries || []).forEach((e) => { (byDate[e.date] = byDate[e.date] || []).push(e); });
  const todayStr = (() => { const t = new Date(); return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`; })();

  return (
    <div data-testid="month-calendar">
      <div className="flex items-center justify-between mb-3">
        <button data-testid="cal-prev" onClick={() => setYm(m === 0 ? [y - 1, 11] : [y, m - 1])} className="w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center active:scale-90 transition-transform"><CaretLeft size={16} weight="bold" /></button>
        <p className="font-heading font-bold text-stone-800">{monthName}</p>
        <button data-testid="cal-next" onClick={() => setYm(m === 11 ? [y + 1, 0] : [y, m + 1])} className="w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center active:scale-90 transition-transform"><CaretRight size={16} weight="bold" /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center mb-1">
        {WD.map((w) => <span key={w} className="text-[11px] font-bold text-stone-400">{w}</span>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (d === null) return <div key={i} />;
          const ents = byDate[ds(d)] || [];
          const filled = ents.length > 0;
          const bg = filled ? (COLOR_MAP[ents[0].color] || "bg-primary") : (ds(d) === todayStr ? "bg-primary/5" : "bg-white");
          const border = filled ? "border-transparent" : (ds(d) === todayStr ? "border-primary" : "border-stone-100");
          const txt = filled ? "text-white" : "text-stone-700";
          return (
            <button key={i} data-testid={`cal-day-${d}`} onClick={() => onDayClick(ds(d))}
              className={`aspect-square rounded-xl border flex flex-col items-center justify-center overflow-hidden active:scale-95 transition-transform ${bg} ${border}`}>
              <span className={`text-sm font-bold ${txt}`}>{d}</span>
              {ents.length > 1 && <span className={`text-[10px] leading-none ${filled ? "text-white/90" : "text-stone-400"}`}>+{ents.length - 1}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
